
    var riot = require('riot')
    
riot.tag2('btn-sns', '<ul class="sns"> <li class="{name}" each="{btns}"><a href="{url}" target="_blank">{name}</a></li> </ul>', '', '', function(opts) {
    var self = this;

    var shareUrl = encodeURI(document.URL);
    var shareTitle = encodeURI(document.title);

    self.btns = [
      {
        name: "twitter",
        url: `//twitter.com/intent/tweet?text=${shareTitle}&url=${shareUrl}`
      },
      {
        name: "facebook",
        url: `//www.facebook.com/sharer.php?u=${shareUrl}`
      },
      {
        name: "line",
        url: `//line.me/R/msg/text/?[${shareTitle}][${shareUrl}]`
      }
    ]
});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/btn-sns.tag